import React from "react";

export const ONB_STATUS = {
  pending: { label: "Pendiente", fg: "#a3a3a3" },
  in_progress: { label: "Formulario en curso", fg: "#60a5fa" },
  completed: { label: "Formulario completado", fg: "#4ade80" },
  draft_generated: { label: "Borrador generado", fg: "#c084fc" },
  pending_approval: { label: "Pendiente de aprobación", fg: "#facc15" },
  active: { label: "Activo", fg: "#22c55e" },
};
export const PAY_STATUS = {
  pending: { label: "Pago pendiente", fg: "#facc15" },
  confirmed: { label: "Pago confirmado", fg: "#4ade80" },
  rejected: { label: "Pago rechazado", fg: "#f87171" },
};
export const LINK_STATE = {
  none: { label: "Sin enlace", fg: "#737373" },
  active: { label: "Enlace activo", fg: "#4ade80" },
  invalidated: { label: "Enlace invalidado", fg: "#f87171" },
  expired: { label: "Enlace caducado", fg: "#fb923c" },
};

export const Pill = ({ map, k, testid }) => {
  const c = map[k] || { label: k || "—", fg: "#a3a3a3" };
  return <span data-testid={testid} style={{ border: `1px solid ${c.fg}`, color: c.fg, padding: "2px 9px", fontSize: 11, borderRadius: 999, fontWeight: 600, whiteSpace: "nowrap" }}>{c.label}</span>;
};

export const Card = ({ title, children, testid, right }) => (
  <div data-testid={testid} style={{ background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.06)", borderRadius: 4, padding: 18, marginBottom: 16 }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12, gap: 8, flexWrap: "wrap" }}>
      <div style={{ fontSize: 11, letterSpacing: "0.2em", textTransform: "uppercase", color: "#E11D2E", fontWeight: 700 }}>{title}</div>
      {right}
    </div>
    {children}
  </div>
);

export const FormRow = ({ label, children }) => (
  <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 11, letterSpacing: "0.14em", textTransform: "uppercase", color: "#a3a3a3" }}>
    {label}{children}
  </label>
);

export const grid2 = { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: 14 };

export const addMonths = (iso, m) => {
  if (!iso || !m) return "";
  const [y, mo, d] = iso.split("-").map(Number);
  const t = new Date(Date.UTC(y, mo - 1 + Number(m), 1));
  const last = new Date(Date.UTC(t.getUTCFullYear(), t.getUTCMonth() + 1, 0)).getUTCDate();
  t.setUTCDate(Math.min(d, last));
  return t.toISOString().slice(0, 10);
};
